import React, { useMemo, useState } from 'react';
import RMTable from 'components/customComponents/Controls/RMTable';
import { DateFilters, PlatesToImageCols, getHeaderDeleteButton } from './utils';
import { ImagingSchedulesDeletedDataDTO, PlatesToImageDTO } from 'business/models/Models';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { setImagingSchedulesIsDirty } from 'redux/reducers/imagingSchedulesReducer';
import { useDispatch } from 'react-redux';
interface PlatesToImageProps {
  platesToImage: PlatesToImageDTO[];
  setPlatesToImage: React.Dispatch<React.SetStateAction<PlatesToImageDTO[]>>;
  setDeletedData: React.Dispatch<React.SetStateAction<ImagingSchedulesDeletedDataDTO>>;
}

function PlatesToImage(props: PlatesToImageProps) {
  const { platesToImage, setPlatesToImage, setDeletedData } = props;
  const [selectedIds, setSelectedIds] = useState<number[]>();
  const [selectedOption, setSelectedOption] = useState<string>('all');
  const dispatch = useDispatch();

  const tableData = useMemo(() => {
    if (platesToImage) {
      if (selectedOption === 'all') {
        return platesToImage?.map((p: PlatesToImageDTO) => ({
          id: p.id,
          dateToImage: p.dateToImage,
          user: p.user,
          experimentName: p.experimentName,
          experimentId: p.experimentId,
          plateNumber: p.plateNumber,
        }));
      } else {
        return platesToImage
          ?.filter((item) => {
            const days = parseInt(selectedOption, 10);
            const currentDate = new Date();
            const itemDate = new Date(item.dateToImage);
            const timeDiff = currentDate.getTime() - itemDate.getTime();
            const diffDays = timeDiff / (1000 * 3600 * 24);
            return diffDays <= days;
          })
          .map((p: PlatesToImageDTO) => ({
            id: p.id,
            dateToImage: p.dateToImage,
            user: p.user,
            experimentName: p.experimentName,
            experimentId: p.experimentId,
            plateNumber: p.plateNumber,
          }));
      }
    }
    return [];
  }, [platesToImage, selectedOption, selectedIds]);

  const onDelete = () => {
    const ids = selectedIds.map((i) => platesToImage[i]?.id);
    const newData = platesToImage.filter((x) => !ids.includes(x.id));
    setPlatesToImage(newData);
    setDeletedData(
      (prevData) =>
        new ImagingSchedulesDeletedDataDTO({
          ...prevData,
          imagingTaskClearedFromToImageIds: Array.from(
            new Set([...(prevData?.imagingTaskClearedFromToImageIds || []), ...ids]),
          ),
        }),
    );
    dispatch(setImagingSchedulesIsDirty(true));
    setSelectedIds([]);
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    setSelectedIds([]);
  };

  const onCheckboxSelectionChange = (rowIndices: number[]) => {
    setSelectedIds([...rowIndices]);
  };

  const handleOnRowCLick = (row) => {
    setSelectedIds([row.index]);
  };

  const handleRowDoubleClick = (row: any) => {
    window.open(`/exp/${row.original.experimentId}`, `/exp/${row.original.experimentId}`);
  };

  const deleteButton = getHeaderDeleteButton(onDelete, selectedIds?.length > 0);

  return (
    <div id="platestoimage-wrapper" className="flex flex-col h-[90%]">
      <div
        id="platestoimage-container"
        className="flex flex-row items-center justify-between py-2"
      >
        <div id="platestoimage-title" className="text-lg font-bold mx-2">
          Plates To Image
        </div>
        <div
          id="platestoimage-lists"
          className="flex flex-row text-lg font-bold mx-2 gap-2"
        >
          <RMCustomButton {...deleteButton} />
          <select
            id="platestoimage-option"
            value={selectedOption}
            onChange={(e) => handleSelectChange(e)}
          >
            {DateFilters.map((f, i) => (
              <option
                id={`platestoimage-option-datefilter${i}`}
                key={`df${i}`}
                value={f.value}
              >
                {f.title}
              </option>
            ))}
          </select>
        </div>
      </div>
      <RMTable
        columns={PlatesToImageCols}
        data={tableData}
        tableClass="w-full"
        selectedIds={selectedIds}
        onCheckboxSelectionChange={onCheckboxSelectionChange}
        onRowClicked={handleOnRowCLick}
        onRowDoubleClicked={handleRowDoubleClick}
        enableMultiSelection
      />
    </div>
  );
}

export default PlatesToImage;
